export function getCurrentFilters(parent) {
    const api = JSON.parse(parent.dataset.rest);
    const dropdownFilters = parent.querySelectorAll('[data-filter="dropdown"]');
    const buttonFilters = parent.querySelectorAll('[data-filter="button"].active');
    const search = parent.querySelector('[data-filter-type="search"] input[type="search"]');
    const { order, orderBy, systemTaxQuery } = api;
    if (!dropdownFilters && !buttonFilters && !!order && !!orderBy && !search) {
        return '';
    }

    const apiFilters = [];

    const queryFilters = {};
    if (order) {
        queryFilters['order'] = order;
    }

    if (orderBy) {
        queryFilters['orderBy'] = orderBy;
    }

    if (systemTaxQuery) {
        queryFilters['systemTags'] = systemTaxQuery['ct_blog-tag'].join(',');
    }

    const queryParams = new URLSearchParams(queryFilters).toString();
    apiFilters.push(queryParams);

    if (search) {
        const value = search.value;

        if (value && value !== '') {
            const params = new URLSearchParams({ s: value }).toString();
            apiFilters.push(params);
        }
    }

    if (dropdownFilters) {
        const filters = {};
        dropdownFilters.forEach((filter) => {
            if (!filter.checked) {
                return;
            }

            const taxonomy = filter.name;
            const term = filter.value;
            filters[taxonomy] = filters[taxonomy] || [];
            filters[taxonomy] = filters[taxonomy].concat(term);
        });

        const params = new URLSearchParams();
        Object.keys(filters).forEach((tax) => {
            params.set(tax, filters[tax]);
        });

        const paramString = params.toString();

        if (paramString !== '') {
            apiFilters.push(paramString);
        }
    }

    if (buttonFilters) {
        const filters = {};
        buttonFilters.forEach((filter) => {
            const { filterTaxonomy, filterTerm } = filter.dataset;
            filters[filterTaxonomy] = filters[filterTaxonomy] || [];
            filters[filterTaxonomy] = filters[filterTaxonomy].concat(filterTerm);
        });

        const params = new URLSearchParams();
        Object.keys(filters).forEach((tax) => {
            params.set(tax, filters[tax]);
        });

        const paramString = params.toString();

        if (paramString !== '') {
            apiFilters.push(paramString);
        }
    }

    return apiFilters.join('&');
}
